<mat-form-field appearance="fill">
  <mat-label>Enter a date range</mat-label>
  <mat-date-range-input [rangePicker]="picker">
    <input matStartDate (dateInput)="onInput('startDateInput',$event)" (dateChange)="onChange('startDateInput',$event)" formControlName="startDate" placeholder="start date">
    <input matEndDate (dateInput)="onInput('endDateInput',$event)" (dateChange)="onChange('endDateInput',$event)" formControlName="endDate" placeholder="end date">
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker ></mat-date-range-picker>
</mat-form-field>
